import { Ng2StateDeclaration } from '@uirouter/angular';
import { DocumentEditComponent } from '@fi-app/document/edit/edit.component';
import { FiDocumentStatesResolveDefaultDocumentSettings } from '@fi-app/document/states/resolve/default-document-settings';
import { FiDocumentStatesResolveDefaultTemplateSettings } from '@fi-app/document/states/resolve/default-template-settings';
import { FiDocumentStatesResolvePageTitle } from '@fi-app/document/states/resolve/document-page-title';
import { FiDocumentStatesResolveDocument } from '@fi-app/document/states/resolve/document';
import { FiDocumentStatesResolveDocumentTemplates } from '@fi-app/document/states/resolve/document-templates';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiDocumentStatesResolveRecentAIRequests } from '@fi-app/document/states/resolve/recent-ai-requests';

export const FiDocumentEditState: Ng2StateDeclaration = {
    name: FiStateNames.Document.Edit,
    url: '/:Id/Edit?languageId?isSettingsExpanded',
    reloadOnSearch: false,
    views: {
        '@': {
            component: DocumentEditComponent,
        },
    },
    resolve: {
        document: FiDocumentStatesResolveDocument,
        defaultDocumentSettings: FiDocumentStatesResolveDefaultDocumentSettings,
        defaultTemplateSettings: FiDocumentStatesResolveDefaultTemplateSettings,
        pageTitle: FiDocumentStatesResolvePageTitle,
        documentTemplates: FiDocumentStatesResolveDocumentTemplates,
        recentAIRequests: FiDocumentStatesResolveRecentAIRequests,
    },
};
